// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FlowerFilledSvg from "@fishx/icons-svg/es/asn/FlowerFilled";
import FishxIcon from '../components/FishxIcon';

var FlowerFilled = function FlowerFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FlowerFilledSvg
  }));
};

FlowerFilled.displayName = 'FlowerFilled';
export default React.forwardRef(FlowerFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FlowerFilled.js
// module id = 2789
// module chunks = 0